import React from 'react'
import PropTypes from 'prop-types'
import { Textfit } from 'react-textfit'

import './PathologyBox.css'
import ImmunizationRecommendation from '../../../../../../models/ImmunizationRecommendion/ImmunizationRecommendation'
import moment from 'moment'
import withPolyglot from '../../../../../common/withPolyglot'

const STATUS_COLORS = {
  ok: '#88d76c',
  late: '#ff6b63',
  present: '#f2cb30',
  attention: '#0a84ff'
}

function getColorForStatus (status) {
  switch (status) {
    case 'late':
      return STATUS_COLORS.late
    case 'present':
      return STATUS_COLORS.present
    case 'attention':
      return STATUS_COLORS.attention
    default:
      return STATUS_COLORS.ok
  }
}

function nextAdministration (date, translate) {
  const today = moment()
  const months = moment(new Date(date)).diff(today, 'month')
  if (months <= 1) {
    const weeks = moment(new Date(date)).diff(today, 'week')
    if (weeks < 2) {
      const days = moment(new Date(date)).diff(today, 'day')
      return translate('numDays', true, 'timing', {smart_count: days})
    } else {
      return translate('numWeeks', true, 'timing', {smart_count: weeks})
    }
  } else {
    return translate('numMonths', true, 'timing', {smart_count: months})
  }
}

// TODO Check message prop

const PathologyBox = (props) => {
  return <div className='uk-height-small pathology-grid-cell'>
    <div
      className={`pathology clickable uk-align-center ${props.isActive ? null : 'pathology-faded'} ${props.hasImmunoglobulin ? 'with-immunoglobulin' : ''}`}
      style={{borderColor: getColorForStatus(props.status)}}
      onClick={() => props.pathologyClickHandle(props.isActive)}>
      <div className='shots'>{`${props.shots.current}/${props.shots.total} ${props.translate('shots')}`}</div>
      {props.message
        ? <div className='message'>
          <Textfit min={12} max={14}>
            {props.message}
          </Textfit>
        </div>
        : null
      }
      {props.nextRecommendation
        ? <div className={`next-info ${props.status === 'late' ? 'warning' : ''}`}>
          <Textfit min={10} max={14}>
            {nextAdministration(props.nextRecommendation.dateCriterion.recommended, props.translate)}
          </Textfit>
        </div>
        : null
      }
      <div className='name' style={{verticalAlign: `${props.message !== undefined ? 'top' : 'middle'}`}}>
        <Textfit min={8} max={16}>
          {props.translate(props.displayKey, true, 'pathologies')}
        </Textfit>
      </div>
    </div>
  </div>
}

PathologyBox.propTypes = {
  displayKey: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  pathologyClickHandle: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  hasImmunoglobulin: PropTypes.bool.isRequired,
  message: PropTypes.string,
  nextRecommendation: PropTypes.instanceOf(ImmunizationRecommendation),
  shots: PropTypes.shape({current: PropTypes.number, total: PropTypes.number}).isRequired
}

// TODO Delete default shots number
PathologyBox.defaultProps = {
  isActive: true,
  shots: {
    current: 0,
    total: 0
  }
}

export default withPolyglot(PathologyBox, 'pathologyBox')
